import { useEffect, useState } from "react";
import MenuBar from "../components/MenuBar";
import HomePage from "../features/home/HomePage";
import SkillsSection from "../features/skills/SkillsSection";
import CompaniesSection from "../features/companies/CompaniesSection";
import ProjectsSection from "../features/projects/ProjectsSection";
import BlogsSection from "../features/blogs/BlogsSection";
import MakeEnquiry from "../features/enquiry/MakeEnquiry";
import LoadingIndicator from "../pages/LoadingIndicator";

const skills = [
  {
    title: "Technologies:",
    skills: "Kotlin, Java, Swift, Dart, Javascript, Typescript, VB.Net.",
  },
  {
    title: "Frameworks/Libraries:",
    skills:
      "Jetpack Compose, SwiftUI, React Native, React, Flutter, Hangfire, WCF.",
  },
  {
    title: "State Management:",
    skills: "ViewModel, LiveData, Flow, BLoC, Redux, Provider, Riverpod.",
  },
  {
    title: "Databases:",
    skills: "Sqlite, MSSQL, MySql.",
  },
  {
    title: "TDD tools:",
    skills: "JUnit, Mockito, Flutter_Test, Jest, Espresso.",
  },
  {
    title: "Task Management tools:",
    skills: "Jira, ClickUp, Trello, Smart Task, and Fresh Release.",
  },
  {
    title: "Crash Reporting and Monitoring tools:",
    skills: "Sentry, Microsoft Clarity, Firebase Crashlytics.",
  },
  {
    title: "CI/CD tools:",
    skills: "CodeMagic, Github Actions.",
  },
  {
    title: "OTA tools:",
    skills: "Shorebird",
  },
  {
    title: "Design tool:",
    skills: "Figma.",
  },
];

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      setIsPageLoaded(true);
    }, 1000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isLoaded]);

  if (!isPageLoaded) {
    return <LoadingIndicator />;
  }

  return (
    <div className="app-shell min-h-screen w-full bg-[#2b2b2b] text-white">
      <MenuBar />
      <div id="home">
        <HomePage />
      </div>
      <div id="skills">
        <SkillsSection items={skills} />
      </div>
      <div id="companies">
        <CompaniesSection />
      </div>
      <div id="projects">
        <ProjectsSection />
      </div>
      <div id="blogs">
        <BlogsSection />
      </div>
      <div id="enquiry">
        <MakeEnquiry />
      </div>

      <footer className="border-t border-white/10 bg-[#1f1f1f] px-4 py-6 text-center text-sm text-white/70 md:text-base">
        <p>Powered by React. © {currentYear}</p>
      </footer>
    </div>
  );
}

export default App;
